import { useState } from "react";
import IconArrowDown from "public/images/sorting-arrow-down.svg";
import IconArrowSide from "public/images/sorting-arrow-side.svg";
import { useTranslation } from "react-i18next";

type ComponentProps = {
  title: string;
  data: any[];
  isText?: boolean;
  limit?: number;
  isMultiLevel?: boolean;
};

export function CustomAccordion({
  title = "",
  data = [],
  isText,
  limit = 3,
  isMultiLevel = false,
}: ComponentProps) {
  const [viewMore, setViewMore] = useState(false);
  const { t } = useTranslation();
  return (
    <ul>
      <span className="font-normal">{title}</span>
      {isMultiLevel ? (
        data.map((el: any, idx: number) => {
          if (idx < limit || viewMore) {
            return (
              <div key={idx}>
                <ul>
                  <li>
                    {el?.title}
                    {el?.items.map((item, idx) => (
                      <li key={`item_${idx}`}>{item.value}</li>
                    ))}
                  </li>
                </ul>
              </div>
            );
          }
        })
      ) : !isText ? (
        data.map((el, idx) => {
          if (idx < limit || viewMore) {
            return (
              <div key={idx}>
                <li>{el}</li>
              </div>
            );
          }
        })
      ) : (
        <li>
          {data.map((el, idx) => {
            if (idx < limit || viewMore) {
              return idx === data.length - 1 ? el : el + ", ";
            }
          })}
        </li>
      )}
      {data?.length > limit ? (
        <div
          className="mt-2 ml-6 cursor-pointer"
          onClick={() => setViewMore(!viewMore)}
        >
          {viewMore ? `${t("view_less")}` : `${t("view_more")}`}{" "}
          {viewMore ? <IconArrowSide /> : <IconArrowDown />}
        </div>
      ) : null}
    </ul>
  );
}
